







































import {Vue, Component, Prop, Watch} from "vue-property-decorator";
import {User as IFollower, Request} from "@/modules/request/Request";
import _ from "lodash";
import {Getter} from "vuex-class";
import {User} from "front-component/modules/User";
import RequestRepository from "@/repositories/request/RequestRepository";

interface Follower {
    uuid: string | null;
    followers: IFollower[];
}

@Component({})
export default class Followers extends Vue {
    private followers: IFollower[] = [];
    private loading: boolean = false;

    @Prop() private request!: Request;

    @Getter("getCurrentUser") public currentUser!: User;

    @Watch("request.uuid")
    private changeRequest() {
        this.updateFollowers();
    }

    private mounted() {
        this.updateFollowers();
    }

    private get alreadyFollow(): boolean {
        return -1 !== _.findIndex(this.followers, (user: IFollower) => {
            return user.uuid === this.currentUser.uuid;
        });
    }

    private updateFollowers(afterUpdate: Promise<void> | null = null): void {
        if (!this.request) {
            return;
        }

        this.loading = true;
        const followersParams = {
            fields: [
                "uuid",
                "followers.uuid",
                "followers.displayName",
            ],
            filters: {
                uuid: this.request.uuid,
            }
        };

        RequestRepository.get(followersParams).then((requests) => {
            this.followers = _.get(requests, "0.followers", []);
            if (!_.isNull(afterUpdate)) {
                afterUpdate.then(() => {
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            } else {
                this.loading = false;
            }
        });
    }

    private handleFollow(): void {
        this.updateFollowers(new Promise<void>((resolve, reject) => {
            const followerParams = {
                fields: [
                    "uuid",
                    "followers.uuid",
                    "followers.displayName",
                ]
            };

            const followersData: Follower = {
                uuid: this.request.uuid,
                followers: this.followers,
            };

            if (this.alreadyFollow) {
                followersData.followers = _.filter(followersData.followers, (user: any) => {
                    return user.uuid !== this.currentUser.uuid;
                });
            } else {
                followersData.followers.push({uuid: this.currentUser.uuid});
            }

            RequestRepository.save(followersData, followerParams).then((request) => {
                this.followers = _.get(request, "followers", []);
                resolve();
            }).catch(() => {
                this.$message({
                    type: "error",
                    message: _.invoke(this.$options.filters, "trans", "failedFollow"),
                });
                reject("failedFollow");
            });
        }));
    }
}
